import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { serializeClasses } from 'utilities/css';

const OverflowContainer = styled.div`
  overflow: hidden;
  &.wrap {
    white-space: pre-wrap;
  }
  &.ellipsis,
  &[class~="..."] {
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const Overflow = ({
  children, overflow, className, ...rest
}) => {
  const classes = serializeClasses([overflow, className]);
  return (
    <OverflowContainer {...rest} className={classes}>
      {children}
    </OverflowContainer>
  );
};

Overflow.propTypes = {
  children: PropTypes.node.isRequired,
  overflow: PropTypes.oneOf(['wrap', 'ellipsis', '...']),
  className: PropTypes.string,
};

Overflow.defaultProps = {
  overflow: 'wrap',
  className: undefined,
};
